
<template>
  <div class="cov-google">
    <div class="col-md-12 p-0">
      <textarea
        type="text"
        id="input_address"
        class="form-control"
        v-model="input_address"
        placeholder="Enter address"
        ref="autocomplete"
        v-on:keyup="resetPlace()"
        :disabled="disable"
      ></textarea>
      <a
        href="javascript:;"
        class="btn btn-primary"
        @click="find()"
        v-show="validation_false < 3"
        ><i class="ti ti-search"></i> Find Address</a
      >
      <!-- hidden element -->
      <small v-show="validation_false >= 3" class="text-secondary"
        >Enter / Copy the latitude from google maps</small
      >
      <input
        :type="validation_false > 2 ? 'text' : 'hidden'"
        id="input_lat"
        v-model="model.latitude"
        placeholder="Enter Latitude ..."
      />
      <small v-show="validation_false >= 3" class="text-secondary"
        >Enter / Copy the longitude from google maps</small
      >
      <input
        :type="validation_false > 2 ? 'text' : 'hidden'"
        id="input_lon"
        v-model="model.longitude"
        placeholder="Enter Longitude ..."
      />
    </div>
    <div class="col-md-12 p-0" v-show="validation_false < 3">
      <div class="google-map" :id="mapName">
        <div class="p-3">Please enter valid address.</div>
      </div>
      <small
        ><i class="ti ti-info-alt text-info"></i> Drag the marker to help you
        find the detail address</small
      >
    </div>
  </div>
</template>

  
<script>
import gmapsInit from "../utils/gmaps";

export default {
  props: ["name", "default_model", "disable", "location_bias"],
  data: function () {
    return {
      
      mapName: this.name + "-map",
      input_address: "",
      validation_false: 0,
      map: null,
      marker: null,
      model: [],
      googleApi: null,
      locationBiasRequest: 0,
    };
  },
  created(){
      // console.log(this.input_address);
  },
  async mounted() {
    // console.log(this.default_model)
    try {
      const google = await gmapsInit();
      this.googleApi = google;
      this.model = this.default_model;
      if (this.default_model.latitude) {
        // console.log(this.default_model.latitude);
        this.initialMap();
        this.input_address = this.default_model.address;
      }
      this.initialGeocomplete();
      this.applyLocationBias();
    } catch (error) {
      console.error(error);
    }
  },

  watch: {
    location_bias: {
      deep: true,
      handler() {
        this.applyLocationBias();
      },
    },
  },

  methods: {
    initialMap() {
      const mapCentre = {
        lat: Number(this.model.latitude),
        lng: Number(this.model.longitude),
      };
      if (!Number.isFinite(mapCentre.lat) || !Number.isFinite(mapCentre.lng)) {
        return;
      }
      this.map = new google.maps.Map(document.getElementById(this.mapName), {
        center: mapCentre,
        zoom: 15,
        geocodeAfterResult: false,
      });
      this.marker = new google.maps.Marker({
        position: mapCentre,
        map: this.map,
        draggable: true,
        optimized: false,
        title: "Drag marker to adjust the address",
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 9,
          fillColor: "#e53935",
          fillOpacity: 1,
          strokeColor: "#ffffff",
          strokeWeight: 3,
        },
      });
      this.initialGeoDrag();
      google.maps.event.addListener(this.map, "click", (event) => {
        this.marker.setPosition(event.latLng);
        this.updateMarkerLocation(event.latLng);
      });
    },

    initialGeoDrag() {
      if (!this.marker) return;
      google.maps.event.addListener(this.marker, "dragend", (event) => {
        this.updateMarkerLocation(event.latLng);
      });
    },

    updateMarkerLocation(latLng) {
      const latitude = latLng.lat();
      const longitude = latLng.lng();
      this.model = { latitude, longitude };
      document.getElementById("input_lat").value = latitude;
      document.getElementById("input_lon").value = longitude;
      this.emitLocation();

      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: latLng }, (results, status) => {
        if (status !== google.maps.GeocoderStatus.OK || !results[0]) return;
        this.input_address = results[0].formatted_address;
        document.getElementById("input_address").value = this.input_address;
        this.emitLocation();
      });
    },

    emitLocation() {
      this.$emit("locationChanged", {
        address: this.input_address || "",
        latitude: this.model.latitude,
        longitude: this.model.longitude,
      });
    },

    initialGeocomplete() {
      const options = { types: ["geocode"] };
      if (this.location_bias) {
        options.componentRestrictions = { country: "id" };
      }
      this.autocomplete = new google.maps.places.Autocomplete(
        this.$refs.autocomplete,
        options
      );
    },

    applyLocationBias() {
      if (!this.googleApi || !this.autocomplete || !this.location_bias) return;

      const city = this.location_bias && this.location_bias.city;
      const province = this.location_bias && this.location_bias.province;
      const country =
        (this.location_bias && this.location_bias.country) || "Indonesia";

      this.autocomplete.setComponentRestrictions({ country: "id" });
      if (!city) {
        this.autocomplete.setOptions({ strictBounds: false });
        return;
      }

      const requestId = ++this.locationBiasRequest;
      const geocoder = new this.googleApi.maps.Geocoder();
      geocoder.geocode(
        { address: [city, province, country].filter(Boolean).join(", ") },
        (results, status) => {
          if (
            requestId !== this.locationBiasRequest ||
            status !== this.googleApi.maps.GeocoderStatus.OK ||
            !results[0]
          ) {
            return;
          }

          const viewport = results[0].geometry.viewport;
          const location = results[0].geometry.location;
          const bounds =
            viewport ||
            new this.googleApi.maps.LatLngBounds(location, location);
          this.autocomplete.setOptions({ bounds, strictBounds: true });
        }
      );
    },

    resetPlace() {
        
      //this.autocomplete.set('place', null);
    },

    find() {
      if (this.input_address == "") {
        alert("Please insert address!");
        this.resetInput();
        return;
      }

      let place = this.autocomplete.getPlace();
      if (place && place.geometry && place.geometry.location) {
        if (
          place.geometry.location.lat() !== "" &&
          place.geometry.location.lng() !== ""
        ) {
          let current_address = place.formatted_address;
          let current_lat = place.geometry.location.lat();
          let current_lon = place.geometry.location.lng();
          this.input_address = current_address;
          // recall map
          this.model = { latitude: current_lat, longitude: current_lon };
          this.initialMap();
          this.emitLocation();
        } else {
          this.validation_false++;
          alert(
            "Google cannot found the address, please try another address or drag marker !"
          );
        }
      } else {
        this.validation_false++;
        if (this.validation_false < 3) {
          alert(
            "Google cannot found the address, please try another address or drag marker !"
          );
          this.resetInput();
          return;
        }
      }

      if (this.validation_false > 2) {
        alert(
          "Sorry you already input more than 3 times, the address still not recognize in google, system suggests you to input manual Address, Latitude and Longitude"
        );
        return;
      }
    },

    resetInput() {
      document.getElementById("input_address").value = "";
      document.getElementById("input_lat").value = "";
      document.getElementById("input_lon").value = "";
    },
  },
};
</script>

<style lang='scss' scoped>
.cov-google {
  float: left;
  width: 100%;
  input[type="text"] {
    padding: 5px;
    width: 100%;
    margin-bottom: 10px;
  }
  .google-map {
    width: 100%;
    height: 270px;
    margin: 0 auto;
    margin-bottom: 10px;
    background: #ececec;
  }
}

#input_address {
  float: left;
  width: 100%;
  margin-right: 10px;
  margin-bottom: 10px;
}
.btn {
  width: 100%;
  margin-bottom: 10px;
}
</style>
